import React from 'react';

const Footer = () => {
  const socialLinks = [
    {
      name: "WhatsApp",
      icon: "fab fa-whatsapp",
      url: "https://wa.me/919654495307",
      color: "#25d366",
      hoverColor: "#128c7e"
    },
    {
      name: "Facebook",
      icon: "fab fa-facebook-f",
      url: "https://www.facebook.com/share/16XxYTpgu3",
      color: "#1877f2",
      hoverColor: "#166fe5"
    },
    {
      name: "Instagram",
      icon: "fab fa-instagram",
      url: "https://www.instagram.com/shree_aesthetics_by_drdeepika",
      color: "#e4405f",
      hoverColor: "#d62976"
    },
    // {
    //   name: "YouTube",
    //   icon: "fab fa-youtube",
    //   url: "#",
    //   color: "#ff0000",
    //   hoverColor: "#cc0000"
    // },
    // {
    //   name: "LinkedIn",
    //   icon: "fab fa-linkedin-in",
    //   url: "#",
    //   color: "#0077b5",
    //   hoverColor: "#005885"
    // },
    // {
    //   name: "Twitter",
    //   icon: "fab fa-twitter",
    //   url: "#",
    //   color: "#1da1f2",
    //   hoverColor: "#1a91da"
    // }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-info">
            <h3>Dr. Deepika Sinha's Aesthetic Clinic</h3>
            <p>Expert Cosmetic & Reconstructive Surgery in Bhopal</p>
            <div className="contact-info">
              <p>📞 <a href="tel:+91-9654495307">+91-9654495307</a></p>
              <a href="https://maps.app.goo.gl/8UCFxac7bxHciPc78" target="_blank">📍 1st floor, 60, Akriti Ecocity Road, Akriti Ecocity, Bawadiya Kalan, Bhopal</a>
            </div>
          </div>
          
          <div className="social-media">
            <h4>Follow Us (Coming soon)</h4>
            <div className="social-links">
              {socialLinks.map((social, index) => (
                <a 
                  key={index} 
                  href={social.url} 
                  className="social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  title={social.name}
                  style={{'--social-color': social.color, '--social-hover': social.hoverColor}}
                >
                  <i className={social.icon}></i>
                </a>
              ))}
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2024 Dr. Deepika Sinha's Aesthetic Clinic. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;